import { useHostName } from '../services/hostName';
import { useRouter } from './useRouter';

export const useAbsoluteUrl = () => {
  const router = useRouter();

  const host = useHostName();

  return `https://${host}${router?.asPath}`;
};
